module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Dedication"
  }, [_vm._v("This faithful but unpretending record"), _c('br'), _vm._v("of a remarkable adventure"), _c('br'), _vm._v("is hereby respectfully dedicated"), _c('br'), _vm._v("by the narrator,"), _c('br'), _c('br'), _vm._v("ALLAN QUATERMAIN,"), _c('br'), _c('br'), _vm._v("to all the big and little boys"), _c('br'), _vm._v("who read it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14796c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled11.vue
// module id = 66
// module chunks = 0